import { GlobalStyles } from "@mui/material";

/**
 * The global grid theme forces `white-space: normal !important` and centres every cell, so a
 * long value wraps out of a fixed row height and text reads as if it were a number. Grids add
 * these classes to their columns and render the styles once.
 */
export const ONE_LINE_CELL_CLASS = "dxt-one-line";
export const TEXT_CELL_CLASS = "dxt-cell-text";
export const NUMBER_CELL_CLASS = "dxt-cell-number";
export const HEADER_PAD_CLASS = "dxt-header-pad";

export const OneLineCellStyles = () => (
	<GlobalStyles
		styles={{
			[`.ag-cell.${ONE_LINE_CELL_CLASS}`]: {
				whiteSpace: "nowrap !important",
				overflow: "hidden",
			},
			[`.ag-cell.${ONE_LINE_CELL_CLASS} .ag-cell-value`]: {
				maxWidth: "100%",
				overflow: "hidden",
				textOverflow: "ellipsis",
				whiteSpace: "nowrap",
			},
			[`.ag-header-cell.${HEADER_PAD_CLASS}`]: {
				padding: "0 4px !important",
			},
			[`.ag-cell.${TEXT_CELL_CLASS}`]: {
				justifyContent: "flex-start !important",
				textAlign: "left !important",
				paddingLeft: "6px !important",
			},
			[`.ag-cell.${NUMBER_CELL_CLASS}`]: {
				justifyContent: "flex-end !important",
				textAlign: "right !important",
				paddingRight: "6px !important",
				fontVariantNumeric: "tabular-nums",
			},
		}}
	/>
);
